/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';

export interface ReleaseObject {
  id: number;
  name: string;
}

interface ReleasesAssignedWireFormat {
  renderable_type: RenderableType;
  releases: ReleaseObject[];
}

export default class ReleasesAssigned {
  readonly renderableType: RenderableType = RenderableType.ReleasesAssigned;
  readonly releases: ReleaseObject[];

  constructor(releases: ReleaseObject[]) {
    this.releases = releases;
  }

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(json: ReleasesAssignedWireFormat): ReleasesAssigned {
    return new ReleasesAssigned(json.releases ?? []);
  }
}
